import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { activity } from '../api/history.ts';
import { useAuth } from '../store/auth.ts';
import { formatBytes, formatRelative, parentPath } from '../lib/format.ts';
import { EmptyState } from '../components/common/EmptyState.tsx';
import { FileIcon } from '../components/files/FileIcon.tsx';
import { IconClock } from '../lib/icons.tsx';
import type { ActivityEntry } from '../api/types.ts';

const ACTION_LABEL: Record<ActivityEntry['action'], string> = {
  add: '추가함', update: '수정함', move: '옮김', delete: '삭제함', restore: '복원함',
};

export function RecentPage() {
  const ns = useAuth((s) => s.namespaces[0]);
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['activity', ns?.id],
    queryFn: () => activity(ns!.id),
    enabled: Boolean(ns),
  });

  if (!ns) return null;
  const entries = data?.entries ?? [];

  return (
    <div className="page">
      <div className="page__head"><h1 className="page__title">최근 항목</h1></div>
      <div className="page__body">
        {isLoading && <div className="empty"><span className="spinner" /></div>}
        {!isLoading && entries.length === 0 && (
          <EmptyState
            icon={<IconClock size={40} className="faint" />}
            title="최근 활동이 없습니다"
          />
        )}
        {entries.map((entry) => (
          <button
            key={entry.seq}
            className="frow"
            style={{ gridTemplateColumns: '32px 1fr 110px 150px 40px', width: '100%' }}
            onClick={() => {
              const target = entry.type === 'folder' ? entry.path : parentPath(entry.path);
              navigate(`/files${target}`);
            }}
          >
            <span />
            <div className="frow__name">
              <FileIcon node={{ type: entry.type, name: entry.path, mime: null }} />
              <span className="frow__label" title={entry.path}>{entry.path}</span>
              <span className="frow__badge">{ACTION_LABEL[entry.action]}</span>
            </div>
            <div className="frow__meta">{entry.size === null ? '—' : formatBytes(entry.size)}</div>
            <div className="frow__meta">
              {formatRelative(entry.created_at)}
              {entry.actor && <span className="faint"> · {entry.actor.name}</span>}
            </div>
            <span />
          </button>
        ))}
      </div>
    </div>
  );
}
